<template>
  <div
    :class="clases"
    :style="{ aspectRatio: relacion }"
    :role="src ? null : 'img'"
    :aria-label="src ? null : etiqueta"
  >
    <img v-if="src" :src="src" :alt="alt" class="size-full object-cover" />
    <span v-else>{{ texto }}</span>
  </div>
</template>

<script>
/**
 * GobMedia
 * Espacio de imagen con dimensión reservada: el hueco no cambia de alto cuando llega el activo real.
 */
export default {
  name: 'GobMedia',
  props: {
    etiqueta: { type: String, required: true },
    texto: { type: String, default: 'Espacio para imagen' },
    relacion: { type: String, default: '16 / 9' },
    src: { type: String, default: null },
    alt: { type: String, default: '' }
  },
  computed: {
    clases() {
      return [
        'flex w-full items-center justify-center overflow-hidden text-center text-gob-0 font-bold tracking-[0.08em] uppercase',
        this.src ? '' : 'border border-dashed border-[#ADB5BD] bg-surface-strong text-[#495057]'
      ]
    }
  }
}
</script>
